import { useEffect } from "react";

export default function useScrollRestoration(key = "scroll_position") {

  // Restore scroll smoothly on mount
  useEffect(() => {
    const savedScroll = sessionStorage.getItem(key);
    if (savedScroll !== null) {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: parseInt(savedScroll, 10),
          behavior: "smooth"
        });
      });
    }
  }, [key]);

  // Save scroll on scroll
  useEffect(() => {
    const saveScroll = () => {
      sessionStorage.setItem(key, window.scrollY);
    };
    window.addEventListener("scroll", saveScroll);
    return () => window.removeEventListener("scroll", saveScroll);
  }, [key]);
}
